var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Trait = require('../models/trait');

InlineVariations.Collections.Traits = Backbone.Collection.extend({
  model: InlineVariations.Models.Trait,
  selectedTraitValues: {},
  initialize: function() {
    return this.on('change:selectedTraitValue', this.changeSelectedTraitValue, this);
  },
  changeSelectedTraitValue: function(model, val) {
    if (val) {
      return this.selectedTraitValues[model.get('name')] = val;
    } else {
      return delete this.selectedTraitValues[model.get('name')];
    }
  },
  someTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length > 0;
  },
  allTraitValuesSelected: function() {
    return _.keys(this.selectedTraitValues).length === this.models.length;
  },
  closeDropdowns: function() {
    var i, len, ref, results, trait;
    ref = this.models;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      results.push(trait.view.closeDropdown());
    }
    return results;
  }
});

module.exports = InlineVariations.Collections.Traits;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9pbmxpbmVfdmFyaWF0aW9ucy9mcm9udGVuZC9jb2xsZWN0aW9ucy90cmFpdHMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9pbmxpbmVfdmFyaWF0aW9ucy9mcm9udGVuZC9jb2xsZWN0aW9ucy90cmFpdHMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsZ0JBQUEscUNBQW1CLE1BQU0sQ0FBQyxtQkFBUCxNQUFNLENBQUMsbUJBQW9COzs7RUFDOUMsZ0JBQWdCLENBQUMsY0FBZTs7OztFQUNoQyxnQkFBZ0IsQ0FBQyxTQUFVOzs7QUFDM0IsZ0JBQWdCLENBQUMsTUFBTSxDQUFDLEtBQXhCLEdBQWdDLE9BQUEsQ0FBUSxpQkFBUjs7QUFFaEMsZ0JBQWdCLENBQUMsV0FBVyxDQUFDLE1BQTdCLEdBQXNDLFFBQVEsQ0FBQyxVQUFVLENBQUMsTUFBcEIsQ0FDcEM7RUFBQSxLQUFBLEVBQU8sZ0JBQWdCLENBQUMsTUFBTSxDQUFDLEtBQS9CO0VBQ0EsbUJBQUEsRUFBcUIsRUFEckI7RUFHQSxVQUFBLEVBQVksU0FBQTtXQUNWLElBQUMsQ0FBQSxFQUFELENBQUksMkJBQUosRUFBaUMsSUFBQyxDQUFBLHdCQUFsQyxFQUE0RCxJQUE1RDtFQURVLENBSFo7RUFNQSx3QkFBQSxFQUEwQixTQUFDLEtBQUQsRUFBUSxHQUFSO0lBQ3hCLElBQUcsR0FBSDthQUNFLElBQUMsQ0FBQSxtQkFBb0IsQ0FBQSxLQUFLLENBQUMsR0FBTixDQUFVLE1BQVYsQ0FBQSxDQUFyQixHQUEwQyxJQUQ1QztLQUFBLE1BQUE7YUFHRSxPQUFPLElBQUMsQ0FBQSxtQkFBb0IsQ0FBQSxLQUFLLENBQUMsR0FBTixDQUFVLE1BQVYsQ0FBQSxFQUg5Qjs7RUFEd0IsQ0FOMUI7RUFZQSx1QkFBQSxFQUF5QixTQUFBO1dBQ3ZCLENBQUMsQ0FBQyxJQUFGLENBQU8sSUFBQyxDQUFBLG1CQUFSLENBQTRCLENBQUMsTUFBN0IsR0FBc0M7RUFEZixDQVp6QjtFQWVBLHNCQUFBLEVBQXdCLFNBQUE7V0FDdEIsQ0FBQyxDQUFDLElBQUYsQ0FBTyxJQUFDLENBQUEsbUJBQVIsQ0FBNEIsQ0FBQyxNQUE3QixLQUF1QyxJQUFDLENBQUEsTUFBTSxDQUFDO0VBRHpCLENBZnhCO0VBa0JBLGNBQUEsRUFBZ0IsU0FBQTtBQUNkLFFBQUE7QUFBQTtBQUFBO1NBQUEscUNBQUE7O21CQUNFLEtBQUssQ0FBQyxJQUFJLENBQUMsYUFBWCxDQUFBO0FBREY7O0VBRGMsQ0FsQmhCO0NBRG9DOztBQXVCdEMsTUFBTSxDQUFDLE9BQVAsR0FBaUIsZ0JBQWdCLENBQUMsV0FBVyxDQUFDIn0=
